import i18next from "i18next";

i18next.init({
  interpolation: {
    escapeValue: false
  },
  lng: "en", // 'en' | 'ar'
  resources: {
    en: {
      translation: {
        TargetCustomers:{
          label:'Number of target customers'
        },
        Login: { label: "Login" },
        Yes: { label: "Yes" },
        No: { label: "No" },
        Job_scheduling:{label:"Your job has been confirmed."},
        sign_in: { label: "SIGN IN" },
        Password: { label: "Password" },
        username: { label: "Username" },
        forgot_pass: { label: "Forgot Password?" },
        FORGET_PASSWORD: { label: "Forgot Password" },
        Send_Code: { label: "Send Code" },
        SMScontent:{label:"Message Content"},
        recipients:{label:"Recipients Number"},
        code: { label: "Code" },
        Check_code: { label: "Check Code" },
        re_pass: { label: "Re-Type Password" },
        Reset_Password: { label: "Reset Password" },
        Dashboard: { label: "Dashboard" },
        Profile: { label: "Profile" },
        SMS: { label: "SMS" },
        create_sub_admin: { label: "Create Sub Admin" },
        Requests: { label: "Requests" },
        Groups: { label: "Groups" },
        Contact: { label: "Contacts" },
        Logout: { label: "Log Out" },
        Close: { label: "Close" },
        Add_Advertisings: { label: "Add Advertisings" },
        Submit: { label: "Submit" },
        Back: { label: "Back" },
        Advertising_Image: { label: "Advertising Image" },
        Link_of_Advertising: { label: "Link of Advertising" },
        Title_of_Advertising: { label: "Title of Advertising" },
        Name_of_Category: { label: "Name of Category" },
        First_Name: { label: "First Name" },
        Second_Name: { label: "Second Name" },
        Family_Name: { label: "Family Name" },
        Job: { label: "Job" },
        Company: { label: "Company" },
        Birthday: { label: "Birthday" },
        Email: { label: "Email" },
        Contractor_Image: { label: "Image" },
        Add_Group: { label: "Add Group" },
        Select_group: { label: "Select group" },
        Name_of_Group: { label: "Name of Group" },
        Select_Category: { label: "Select Category" },
        Add_Request: { label: "Add Request" },
        Request_Sender_ID: { label: "Request Sender ID" },
        Previous: { label: "Previous" },
        Time: { label: "Time" },
        Select_Time: { label: "Select Time" },
        Step_Three: { label: "Step Three" },
        Next: { label: "Next" },
        Sender_ID: { label: "Sender ID" },
        Step_Two: { label: "Step Two" },
        Select_contact: { label: "Select contact" },
        Upload_file: { label: "Upload file" },
        Mobile_Number: { label: "Mobile Number" },
        Recipient_numbers_type: { label: "Recipient numbers type" },
        Title: { label: "Title" },
        Step_One: { label: "Step One" },
        Full_Name: { label: "Full Name" },
        View_Contact: { label: "View Contact" },
        Edit_Advertisings: { label: "Edit Advertisings" },
        Add_Category: { label: "Add Category" },
        Edit_Category: { label: "Edit Category" },
        Add_Contact: { label: "Add Contact" },
        Edit_Contact: { label: "Edit Contact" },
        Add_Sub_Admin: { label: "Add Sub Admin" },
        Edit_Sub_Admin: { label: "Edit Sub Admin" },
        Edit_Group: { label: "Edit Group" },
        Manage_Groups: { label: "Manage Groups" },
        Group_Name: { label: "Group Name" },
        Select_groups: { label: "Select groups" },
        Import: { label: "Import from file" },
        ImportContact: { label: "Import from contacts" },
        Re_type_Password: { label: "Re-Type Password" },
        New_Password: { label: "New Password" },
        Old_Password: { label: "Old Password" },
        Advertising: { label: "Advertising" },
        View_Advertising: { label: "View Advertising" },
        Name: { label: "Name" },
        Delete_Contact: { label: "Delete Contact" },
        deleteAproval: { label: "Are you sure you want to delete this group" },
        deleteAprovalCategory: {
          label: "Are you sure you want to delete this category"
        },
        deleteAprovalContact: {
          label: "Are you sure to delete this/these contact"
        },
        deleteAprovalSubadmin: {
          label: "Are you sure to delete this sub admin"
        },
        deleteAprovalTemplate: {
          label: "Are you sure to delete this template"
        },
        Sub_Admin: { label: "Sub Admin" },
        Category: { label: "Category" },
        Category_Name: { label: "Category Name" },
        email: { label: "Email" },
        birthdate: { label: "Birthdate" },
        Content: { label: "Content" },
        company: { label: "Company" },
        Confirm: { label: "Confirm" },
        totalValid_Number: { label: "Total Valid Number" },
        inValid_Number: { label: "Invalid Number" },
        totalinValid_Number: { label: "Total Invalid Number" },
        totalDuplicate_Number: { label: "Total Duplicate Number" },
        job_title: { label: "Job Title" },
        Status: { label: "Status" },
        numberofmsgs: { label: "Number of Msgs" },
        view_details: { label: "View Details" },
        Message: { label: "Message" },
        Schedule_date: { label: "Schedule Date" },
        total_recipients: { label: "Total Recipients Numbers" },
        totalmsg: { label: "Total messeges" },
        download_sample: { label: "Download sample" },
        Click_to_download_sample: { label: "Click to download sample" },
        Details: { label: "Details" },
        add_balance: { label: "Assign Balance" },
        balance: { label: "Balance" },
        type: { label: "Type" },
        expiry_date: { label: "Expiry Date" },
        billing_code: { label: "Billing Code" },
        enable: { label: "Enable" },
        choose_sub_admin: { label: "Choose sub admin" },
        from: { label: "From" },
        to: { label: "To" },
        time: { label: "Time" },
        landline: { label: "Landline" },
        weight: { label: "Weight" },
        active: { label: "Active" },
        createdTime: { label: "Created Time" },
        total_delievered: { label: "Total Delievered" },
        total_failed: { label: "Total Failed" },
        total_rejected: { label: "Total Rejected" },
        total_submitted: { label: "Total Submitted" },
        View_groups: { label: "View group contacts" },
        total_group_contacts: { label: "Total group contacts" },
        remove_numbers: { label: "Remove numbers" },
        add_numbers: { label: "Add numbers" },
        choose_variables: { label: "Choose variables" },
        custom_filter1: { label: "Custom filter1" },
        custom_filter2: { label: "Custom filter2" },
        custom_filter3: { label: "Custom filter3" },
        custom_filter4: { label: "Custom filter4" },
        custom_filter5: { label: "Custom filter5" },
        custom_filter6: { label: "Custom filter6" },
        area: { label: "Area" },
        country: { label: "Country" },
        district: { label: "District" },
        governerate: { label: "Governate" },
        stop_job: { label: "Stop job" },
        group_selected: { label: "Group selected" },
        create_sender_id: { label: "View sender IDs" },
        sender_id: { label: "Sender ID" },
        choose_account: { label: "Choose account" },
        cancel: { label: "Cancel job" },
        Are_you_sure_about_stopping_the_job: {
          label: "Are you sure about stopping the job?"
        },
        Cancel: { label: "Cancel" },
        total_success: { label: "Total Success" },
        account_expiration: { label: "Account Expiration" },
        Change_Password: { label: "Change Password" },
        Send_password: { label: "Send Password" },
        i_have_a_password: { label: "I have a code" },
        Request_sender_id: { label: "Request Sender ID" },
        Request_balance: { label: "Requests" },
        fir_las: { label: "Please fill firstName and lastName" },
        approve: { label: "Approve" },
        reject: { label: "Reject" },
        contact_us: { label: "Contact Us" },
        your_question: { label: "Your Question" },
        Template: { label: "SMS Templates" },
        template_name: { label: "Template name" },
        text: { label: "Text" },
        type_of_request: { label: "Type of request" },
        Address_book: { label: "Address Book" },
        OK:{label:"OK"},
        manage_sub_accounts: { label: "Manage sub accounts" },
        export_details: { label: "Export details" },
        Are_you_sure_you_want_to_approve_this_request: {
          label: "Are you sure you want to approve this request?"
        },
        approve_request: { label: "Approve request" },
        name: { label: "Name" },
        question: { label: "Question" },
        content:{label :'SMS Content'},
        Are_you_sure_you_want_to_reject_this_request: {
          label: "Are you sure you want to reject this request"
        },
        reject_request: { label: "Reject request" },
        Adv: { label: "Adv" },
        adv: { label: "Adv" },
        manage_accounts: { label: "Manage accounts" },
        create_admin: { label: "Create admin" },
        search: { label: "Search" },
        value: { label: "Value" },
        select: { label: "Select ..." },
        Number: { label: "Number" },
        File: { label: "File" },
        Contact_List: { label: "Contact List" },
        Dynamic_File: { label: "Dynamic File" },
        Group: { label: "Group" },
        Send_Now: { label: "Send Now" },
        Schedule_time: { label: "Schedule time" },
        Sender_ID: { label: "Sender_ID" },
        Balance: { label: "Balance" },
        error: { label: "error" },
        you_do_not_have_this_sender_id: {
          label: "you do not have this sender id"
        },
        you_do_not_have_this_type_of_balance: {
          label: "you do not have this type of balance"
        },
        you_do_not_have_balance: { label: "you do not have balance" },
        warning: { label: "Warning" },
        password_title:{label:'Password must contain :'},
        old_password:{label:'Old password'},
        password_point1:{label:'1- Captial letter.'},
        password_point2:{label:'2- Small letter.'},
        password_point3:{label:'3- Numbers.'},
        password_point4:{label:'4- Special character.'},
        password_point5:{label:'5- length more than 8 digit.'},
        password_point6:{label:'6- Does not contain username.'},
        UploadCSV: { label: "UploadCSV" },
        success: { label: "Success" },
        Please_fill_all_fields: { label: "Please fill all fields" },
        Login_successfully: { label: "Login successfully" },
        Username_password_do_not_match: {
          label: "Username or password does not match"
        },
        Max_length_of_input_15_characters: {
          label: "Max length of input 15 characters"
        },
        duplicate_contact:{label:'Duplicate contact'},
        Password_and_Re_password_not_match: {
          label: "Password and Re-password not match"
        },
        add: { label: "Add" },
        export: { label: "Export" },
        view_report: { label: "View report" },
        edit: { label: "Edit" },
        delete: { label: "Delete" },
        Promotion: { label: "Promotion" },
        UploadIMage: { label: "Upload Image" },
        description: { label: "Description" },
        view_promotion: { label: "View Promotion" },
        viewDetails: { label: "View Details" },
        profile_details: { label: "Profile Details" },
        lba_details: { label: "LBA Details" },
        upload_in_progress:{label:"Upload in progress"},
        lba_desc: {
          label:
            "To reduce cost and increase relevance,you can target your innovative SMS advertisments based on location and other demographic variables"
        },
        survey_details: { label: "Survey Details" },
        survey_desc: {
          label:
            "In order to gather customer sentiments ,we haverecipients according to their location,gender,age,etc.this way research & market analysis can be conducted seamlessly."
        },
        international_details: { label: "International Details" },
        User_name: { label: "User Name" },
        user_type: { label: "User Type" },
        the_request_has_been_approved: {
          label: "The request has been approved"
        },
        the_request_has_been_Rejected: {
          label: "The request has been Rejected"
        },
        balance_reserved: { label: "Balance reserved" },
        BalanceDetails : { label: "Balance Detials" },
        basic_information: { label: "Basic information admin" },
        basic_information_sub: { label: "Basic information subadmin" },
        filter: { label: "Filter" },
        filter_details: { label: "Filter Details" },
        start_date: { label: "Start Date" },
        end_date: { label: "End Date" },
        view_chart: { label: "View Chart" },
        data_filtering: { label: "Data Filtering" },
        admin_chart: { label: "Admin Chart" },
        sub_admin_chart: { label: "Sub Admin Chart" },
        enjoy: { label: "Your data will be available after successful migration." },
        data_migrate: { label: "ستظهر البيانات بعد ترحيلها" },
        corpsms_notification: { label: "CorpSMS Notification" },
        admin_chart_per_day: { label: "Admin chart for day" },
        admin_chart_per_week: { label: "Admin chart for the last 7 days" },
        admin_chart_per_month: { label: "Admin chart for the last 30 days" },
        subadmin_chart_per_day: { label: "Subadmin chart for day" },
        subadmin_chart_per_week: {
          label: "Subadmin chart for the last 7 days"
        },
        subadmin_chart_per_month: {
          label: "Subadmin chart for the last 30 days"
        },
        Are_you_sure_you_want_to_assign_balance: {
          label: "Are you sure you want to assign balance?"
        },
        active_date:{label :"Active Date" },
        active_sender:{label :"Active SenderID" },
        confirm: { label: "Confirm" },
        type_of_balance: { label: "Type of balance" },
        login_faild: { label: "Login failed" },
        Something_wrong: { label: "Something wrong" },
        version: { label: "Version 1.0.2" },
        beta_version: { label: "Beta version" },
        view_admin: { label: "View Admin" },
        view_subadmin: { label: "View SubAdmin" },
        subadmin: { label: "SubAdmin" },
        Remaining_Balance: { label: "Remaining Balance :" },
        Expiry_Date: { label: "Expiry Date " },
        General_SMS :{label :'General SMS'},
        Profiled_SMS: { label: "Profiled SMS" },
        LBA_SMS: { label: "Location based SMS" },
        choose_admin: { label: "Choose admin" },
        Survey_SMS: { label: "Survey Tools" },
        Admin: { label: "Admin" },
        Add_Admin: { label: "Add Admin" },
        View_Admin:{label:'View Admin'},
        Edit_Admin: { label: "Edit Admin" },
        Settings: { label: "Settings" },
        Create_Sub_Admin:{label:'Create Sub Admin'},
        International_SMS: { label: "International SMS" },
        failed:{label:'failed'},
        Please_fill_title_field:{label:'Please fill title field'},
        Please_fill_content_fields:{label:'Please fill content fields'},
        Please_enter_mobile_number:{label:'Please enter mobile number'},
        Pleaseselect_option:{label:"Please select option"},
        otp:{label:'Verification code'},
        
      jobs_history:{label:'Jobs History'},
      get_history:{label:'Get History '},
      date:{label:'Date'},
      please_wait:{label:'Please Wait'},
        verify:{label:'Verify'},
        blocked:{label:'Blocked'},
        profile_desc: {
          label:
            "A Mobile Advertising platform which enables customers to send targeted SMS campaigns based on the   profile   they   select.  Profiled SMS is aimed towards customers who want to purchase targeted advertising where the customer will be selecting the profile of targeted users to receive the campaign materials [work location, home location, age, gender and   nationality."
        },
        lba_desc: {
          label:
            "To reduce costs and increase relevance, you can target your innovative SMS advertisements based on location and other demographic variables."
        },
        survey_desc: {
          label:
            "In order to gather customer sentiments, we have created a simple and efficient tool that targets recipients according to   their   location, gender, age, etc.  This way, research and market analysis can be conducted seamlessly. The survey would be shared by sending a link to their device and a reward would be granted upon completion."
        },
        inter_desc: {
          label:
            "Offers corporate customers the opportunity to send international promotional messages on their clients’ handsets."
        },
        new_Request_Balance:{label:'Request Balance'},
        new_Request_SenderID:{label:'Request SenderID'},
        balance_Type:{label:'Balance Type'}

      }




    },
    ar: {
      translation: {
        TargetCustomers:{
          label:'عدد العملاء المستهدفين'
        },
        View_Admin:{label:'عرض الادارة'},
        Job_scheduling:{label:"تم التأكيد بنجاح"},
        duplicate_contact:{label:'جهة الاتصال موجودة'},
        Pleaseselect_option:{label:"الرجاء اختيار خيار"},
        old_password:{label:'كلمة السر الحالية'},
        password_title:{label:'كلمة السر يجب أن تحتوي على:'},
        password_point1:{label:'1-حرف كبير'},
        password_point2:{label:'2- حرف صغير'},
        upload_in_progress:{label:"جاري التحميل"},
        OK:{label:"موافق"},
        fir_las: { label: "الرجاء ادخال الاسم الاول واسم العائلة" },
        SMScontent:{label:"محتوى الرسالة "},
        recipients:{label:"رقم المستلم"},
        Please_enter_mobile_number:{label:'الرجاء ادخال رقم الهاتف'},
        password_point3:{label:'3- رقم'},
        password_point4:{label:'4- حرف خاص'},
        password_point5:{label:'5- الطول لا يقل عن 8 خانات'},
        password_point6:{label:'6- لا يحتوي على اسم المستخدم'},
        Create_Sub_Admin:{label:'انشاء ادارة فرعية'},
        value: { label: "القيمة" },
        Admin: { label: "الادارة" },
        Edit_Admin: { label: "تعديل الادارة" },
        Add_Admin: { label: "اضافة ادارة" },
        choose_admin: { label: "اختار الادارة" },
        content:{label :'محتوى الرسالة'},
        Profiled_SMS: { label: "Profiled SMS" },
        General_SMS :{label :'General SMS'},
        International_SMS: { label: "رسالة من شركة" },
        Survey_SMS: { label: "أدوات الاستبانة" },
        LBA_SMS: { label: " الاعلان عبر الرسائل القصيرة" },
        version: { label: "Version 1.0.2" },
        Remaining_Balance: { label: "الرصيد المتبقي" },
        Expiry_Date: { label: "تاريخ الانتهاء" },
        Settings: { label: "   إلاعدادات  " },
        
        beta_version: { label: "Beta version" },
        Please_fill_content_fields:{label:'الرجاء كتابة المسج'},
        inter_desc: {
          label:
            "هذه الخدمة تقدم للعملاء من الشركات فرصة لعرض رسائل ترويجية على هواتف عملائهم في دول اخرى عندما يقوم العملاء بلتواصل معهم"
        },
        profile_desc: {
          label:
            "هذه الخدمة تعد منصة رئيسة للاعلانات عبر الهواتف النقالة تمكن العميل من ارسال الاعلانات عبر الرسائل النصية القصيرة الى الفئات المستهدفة بناء على المعلومات المتواجدة على المنصة"
        },
        Something_wrong: { label: "حدث خطأ ما" },
        view_admin: { label: "عرض الادارة" },
        view_subadmin: { label: "عرص الإدارة الفرعية" },
        subadmin: { label: "الإدارةالفرعية" },
        login_faild: { label: "حدث خطأ في تسجيل الدخول" },
        Are_you_sure_you_want_to_assign_balance: {
          label: "هل تريد اعطاء رصيد؟"
        },
      
        deleteAprovalContact: {
          label: "هلا أنت متأكد من حذف جهة/جهات الاتصال "
        },
       
        the_request_has_been_approved: { label: "تمت الموافقة على الطلب" },
        type_of_balance: { label: "نوع الرصيد" },
        confirm: { label: "موافق" },
        data_migrate: { label: "ستظهر البيانات بعد ترحيلها" },
        corpsms_notification: { label: "تنبيه" },
        filter: { label: "تصفية" },
        admin_chart_per_day: { label: "رسمة الادارة ليوم" },
        admin_chart_per_week: { label: "رسمة الادارة لاسبوع الماضي" },
        admin_chart_per_month: { label: "رسمة الادارة لشهر الماضي" },
        subadmin_chart_per_day: { label: "رسمة الادارة الفرعية ليوم" },
        subadmin_chart_per_week: {
          label: "رسمة الادارة الفرعية لاسبوع الماضي"
        },
        subadmin_chart_per_month: { label: "رسمة الادارة الفرعية لشهر الماضي" },
        admin_chart: { label: "رسمة الادارة" },
        sub_admin_chart: { label: "رسمة الادارة الفرعية" },
        data_filtering: { label: "تفاصيل التصفية" },
        start_date: { label: "تاريخ البدء" },
        end_date: { label: "تاريخ الانتهاء" },
        filter_details: { label: "تفاصيل التصفية" },
        balance_reserved: { label: "الرصيد محفوظة" },
        basic_information: { label: "المعلومات الرئيسة للمشرف" },
        basic_information_sub: { label: "المعلومات الرئيسة للادارة الفرعية" },
        the_request_has_been_Rejected: { label: "تم رفض الطلب" },
        profile_details: { label: "التفاصيل" },
        survey_desc: {
          label:
            "هذه خدمة بسيطة وفعالة لاجراء دراسات عن رضاء العملاء حيث أنشأت زين أداة بسيطة وفعالة تستهدف المستفيدين تبعا :لموقعهم جنسهم عمرهم وما الى ذلك وبهذه الطريقة يمكن اجراء الأبحاث وتحليل السوق بسلاسة حيث يتم مشاركة الاستبيان عن طريق ارسال رابط الى اجهزة المستهدفين وسيتم منحهم مكافأة عند الانتهاء من ذلك"
        },
        viewDetails: { label: "عرض التفاصيل" },
        User_name: { label: "اسم المستخدم" },
        user_type: { label: "نوع المستخدم" },
        Please_fill_title_field:{label:'الرجاء تعبئة العنوان'},
        survey_details: { label: "تفاصيل أدوات الاستبانة" },
        lba_desc: {
          label:
            "خدمة الاعلان عبر الرسائل القصيرة التي تستهدف موقعا معينا هو حل مبتكر يسمح للعميل بالوصول الى السوق المستهدف بناء على الموقع الجنس العمر المتغيرات الديموغرافية الاخرى ويمكنه من ارسال اعلانه الترويجي عبر الرسائل النصية القصيرة الى الشريحة المستهدفة بدلا من ارسالها للجميع"
        },
        lba_details: {
          label: "تفاصيل خدمة الاعلان عبر الرسائل القصيرة تستهدف موقعا معينا"
        },
        view_promotion: { label: "مشاهدة العروض" },
        international_details: { label: "تفاصيل رسالة من الشركة" },
        description: { label: "الوصف" },
        UploadIMage: { label: "تحميل صورة" },
        Promotion: { label: "الخصومات" },
        edit: { label: "تعديل" },
        delete: { label: "حذف" },
        view_report: { label: "عرض التقرير" },
        add: { label: "اضافة" },
        export: { label: "تنزيل" },
        Max_length_of_input_15_characters: { label: "الحد الأعلى 15 حرف" },
        Password_and_Re_password_not_match: { label: "كلمة السر غير متطابقة" },
        Login_successfully: { label: "تم تسجيل الدخول بنجاح" },
        Username_password_do_not_match: {
          label: "اسم المستخدم او كلمة السر غير متطابقة"
        },
        Please_fill_all_fields: { label: "الرجاء تعبئة جميع الحقول" },
        success: { label: "نجح" },
        UploadCSV: { label: "تحميل ملف" },
        warning: { label: "تحذير" },
        select: { label: "اختر" },
        type_of_request: { label: "نوع الطلب" },
        create_admin: { label: "انشاء حساب رئيسي" },
        search: { label: "بحث" },
        manage_sub_accounts: { label: "تنظيم الحسابات" },
        Login: { label: "دخول" },
        Yes: { label:"نعم" },
        No: { label: "لا" },
        birthdate: { label: "تاريخ الميلاد" },
        sign_in: { label: "تسجيل الدخول" },
        Password: { label: "كلمة المرور" },
        username: { label: "اسم المستخدم" },
        forgot_pass: { label: "هل نسيت كلمة المرور؟" },
        FORGET_PASSWORD: { label: "نسيت كلمة المرور" },
        Send_Code: { label: "ارسال الرمز" },
        code: { label: "الرمز" },
        Check_code: { label: "التأكد من الرمز" },
        re_pass: { label: "اعادة كلمة المرور" },
        Reset_Password: { label: "تغيير كلمة المرور" },
        Dashboard: { label: "لوحة التحكم" },
        Profile: { label: "الملف الشخصي" },
        BalanceDetails : { label: "تفاصيل الرصيد" },
        SMS: { label: "الرسائل" },
        create_sub_admin: { label: "إنشاء إدارة فرعية" },
        Requests: { label: "الطلبات" },
        Groups: { label: "المجموعات" },
        Contact: { label: "جهات الاتصال" },
        Logout: { label: "تسجيل الخروج" },
        Close: { label: "اغلاق" },
        Add_Advertisings: { label: "اضافة اعلانات" },
        Submit: { label: "موافق" },
        Back: { label: "رجوع" },
        Advertising_Image: { label: "صورة الاعلان" },
        Link_of_Advertising: { label: "رابط الإعلان" },
        Title_of_Advertising: { label: "عنوان الاعلان" },
        Name_of_Category: { label: "اسم الفئة" },
        First_Name: { label: "الاسم الأول" },
        Second_Name: { label: "الاسم الثاني" },
        Family_Name: { label: "اسم العائلة" },
        Job: { label: "الوظيفة" },
        Company: { label: "الشركة" },
        Password: { label: "كلمة السر" },
        Birthday: { label: "تاريخ الميلاد" },
        Email: { label: "البريد الالكتروني" },
        Contractor_Image: { label: "تحميل الصورة" },
        Add_Group: { label: "اضافة مجموعة" },
        Select_group: { label: "اختار مجموعة" },
        Name_of_Group: { label: "اسم المجموعة" },
        Select_Category: { label: "اختار الفئة" },
        Add_Request: { label: "اضافة طلب" },
        Request_Sender_ID: { label: "طلب معرف المرسل" },
        Previous: { label: "السابق" },
        Time: { label: "الوقت" },
        Select_Time: { label: "اختار الوقت" },
        Step_Three: { label: "المرحلة الثالثة" },
        Next: { label: "التالي" },
        Sender_ID: { label: "هوية المرسل" },
        Step_Two: { label: "المرحلة الثانية" },
        Contact_List: { label: "قائمة الاتصال" },
        Select_contact: { label: "اختار جهة الاتصال" },
        Upload_file: { label: "تحميل ملف" },
        Mobile_Number: { label: "رقم الموبايل" },
        Recipient_numbers_type: { label: "نوع رقم المستلم" },
        Title: { label: "العنوان" },
        Step_One: { label: "المرحلة الأولى" },
        Full_Name: { label: "الاسم كامل" },
        View_Contact: { label: "عرض جهة الاتصال" },
        Edit_Advertisings: { label: "تعديل الاعلان" },
        Add_Category: { label: "اضافة فئة" },
        Edit_Category: { label: "تعديل فئة" },
        Add_Contact: { label: "اضافة جهة اتصال" },
        Edit_Contact: { label: "تعديل جهة اتصال" },
        Add_Sub_Admin: { label: "اضافة ادارة فرعية" },
        Edit_Sub_Admin: { label: "تعديل ادارة فرعية" },
        Edit_Group: { label: "تعديل المجموعة" },
        Manage_Groups: { label: "ادارة المجموعات" },
        Group_Name: { label: "اسم المجموعة" },
        Select_groups: { label: "اختر المجموعات" },
        Import: { label: "تحميل" },
        Re_type_Password: { label: "اعادة كتابة كلمة السر" },
        New_Password: { label: "كلمة السر لجديدة" },
        Old_Password: { label: "كلمة السر الحالية" },
        Reset_Password: { label: "اعادة تعيين كلمة السر" },
        Advertising: { label: "الاعلانات" },
        View_Advertising: { label: "عرض الاعلانات" },
        Name: { label: "الاسم" },
        Edit_Contact: { label: "تعديل جهة الاتصال" },
        Delete_Contact: { label: "حذف جهة الاتصال" },
        Sub_Admin: { label: "الادارة الفرعية" },
        Category: { label: "الفئة" },
        Category_Name: { label: "اسم الفئة" },
        email: { label: "البريد الالكتروني" },
        Content: { label: "المحتوى" },
        company: { label: "الشركة" },
        Confirm: { label: "تأكيد" },
        totalValid_Number: { label: " مجموع الأرقام الصحيحة" },
        inValid_Number: { label: "الأرقام الخاطئة" },
        totalinValid_Number: { label: "مجموع الأرقام الخاطئة" },
        totalDuplicate_Number: { label: "مجموع الأرقام المكررة" },
        job_title: { label: "العنوان" },
        Status: { label: "الحالة" },
        numberofmsgs: { label: "عدد المسجات" },
        view_details: { label: "عرض التفاصيل" },
        Message: { label: "الرسالة" },
        Schedule_date: { label: "الوقت" },
        total_recipients: { label: "عدد المستلمين" },
        totalmsg: { label: "مجموع الرسائل" },
        download_sample: { label: "تحميل مثال" },
        Click_to_download_sample: { label: "اضغط هنا لتحميل مثال" },
        Details: { label: "التفاصيل" },
        add_balance: { label: "اضافة رصيد" },
        balance: { label: "الرصيد" },
        type: { label: "النوع" },
        expiry_date: { label: "تاريخ الانتهاء" },
        billing_code: { label: "رمز الفاتورة" },
        enable: { label: "تفعيل" },
        choose_sub_admin: { label: "اختر الادارة الفرعية" },
        from: { label: "من" },
        to: { label: "الى" },
        time: { label: "الوقت" },
        landline: { label: "الخط الأرضي" },
        weight: { label: "الحجم" },
        active: { label: "مفعل" },
        createdTime: { label: "وقت الاضافة" },
        failed:{label:'فشل'},
        total_delievered: { label: "مجموع الرسائل المرسلة" },
        total_failed: { label: "مجموع الرسائل لتي لم ترسل" },
        total_rejected: { label: "المسجات المرفوضة" },
        total_submitted: { label: "المسجات المرسلة" },
        View_groups: { label: "عرض المجموعات" },
        total_group_contacts: { label: "مجموع اتصالات المجموعة" },
        remove_numbers: { label: "الأرقام المحذوفة" },
        add_numbers: { label: "الأرقام المضافة" },
        choose_variables: { label: "اختر المتغير" },
        custom_filter1: { label: "الخيار 1" },
        custom_filter2: { label: "الخيار 2" },
        custom_filter3: { label: "الخيار 3" },
        custom_filter4: { label: "الخيار 4" },
        custom_filter5: { label: "الخيار 5" },
        custom_filter6: { label: "الخيار 6" },
        stop_job: { label: "ايقاف" },
        group_selected: { label: "المجموعات المختارة" },
        create_sender_id: { label: "تعريف المرسل" },
        sender_id: { label: "المرسلين" },
        choose_account: { label: "اختار الحساب" },
        cancel: { label: "الغاء العمل" },
        Are_you_sure_about_stopping_the_job: {
          label: "هل انت متأكد من ايقاف العمل؟"
        },
        Cancel: { label: "الغاء" },
        total_success: { label: "مجموع " },
        account_expiration: { label: "تاريخ الصلاحية" },
        Change_Password: { label: "تغيير كلمة السر" },
        Send_password: { label: "ارسال كلمة السر" },
        i_have_a_password: { label: "لدي كلمة السر" },
        Request_sender_id: { label: "تعريف المرسل" },
        Request_balance: { label: "طلبات" },
        approve: { label: "قبول" },
        reject: { label: "رفض" },
        contact_us: { label: "تواصل معنا" },
        your_question: { label: "سؤالك" },
        Template: { label: "نموذج" },
        template_name: { label: "اسم نموذج" },
        text: { label: "النص" },
        Address_book: { label: "دليل العناوين" },
        export_details: { label: "تنزيل" },
        Are_you_sure_you_want_to_approve_this_request: {
          label: "هل انت متأكد من قبول الطلب؟"
        },
        approve_request: { label: "قبول الطلب" },
        name: { label: "الاسم" },
        question: { label: "السؤال" },
        Are_you_sure_you_want_to_reject_this_request: {
          label: "هل انت متأكد من الرفض؟"
        },
        reject_request: { label: "رفض لطلب" },
        Adv: { label: "اعلانات" },
        adv: { label: "اعلانات" },
        manage_sub_accounts: { label: "ادارة الحسابات الفرعية" },
        manage_accounts: { label: "ادارة الحسابات " },
        area: { label: "المنطقة" },
        country: { label: "المدينة" },
        district: { label: "منطقة" },
        governerate: { label: "محافظة" },
        Number: { label: "رقم" },
        File: { label: "ملف" },
        Dynamic_File: { label: "ملف متغير" },
        Group: { label: "مجموعة" },
        Send_Now: { label: "ارسل الان" },
        Schedule_time: { label: "ضبط الوقت" },
        Sender_ID: { label: "هوية المرسل" },
        Balance: { label: "رصيد" },
        error: { label: "خطأ" },
        you_do_not_have_this_sender_id: { label: "لا يتوفر لديك هذا المرسل" },
        you_do_not_have_this_type_of_balance: { label: "ليس لديك رصيد" },
        you_do_not_have_balance: { label: "ليس لديك رصيد" },
        deleteAproval: { label: "هل انت متأكد من حذف هذه المجموعة" },
        deleteAprovalCategory: {
          label: "هل انت متأكد من حذف هذه الفئة"
        },
        view_chart: { label: "عرض الرسم البياني" },
        otp:{label:'رمز التحقق'},
        verify:{label:'تحقق'},
        blocked:{label:'محظور'},
        jobs_history:{label:'سجل الوظائف'},
        get_history:{label:'احصل على السجل'},
        date:{label:'التاريخ'},
        please_wait:{label:'الرجاء الانتظار'},
        new_Request_Balance:{label:'طلب الرصيد'},
        new_Request_SenderID:{label:'تعريف المرسل'},
        balance_Type:{label:'نوع الرصيد'}
      }
    }
  }
});

export default i18next;

